module.exports = __webpack_public_path__ + "img/KepalaCCEDUnila.ecef2c4b.jpg";